import { defineMessages } from 'react-intl';

const cloudinaryLocalizationData = defineMessages({
  or: {
    id: 'shared_components.cloudinary.or',
    defaultMessage: 'Or'
  },
  menu_files: {
    id: 'shared_components.cloudinary.menu_files',
    defaultMessage: 'My Files'
  },
  browse: {
    id: 'shared_components.cloudinary.browse',
    defaultMessage: 'Browse'
  },
  dd_title_single: {
    id: 'shared_components.cloudinary.drop_asset',
    defaultMessage: 'Drag and Drop an asset here'
  },
  dd_title_multi: {
    id: 'shared_components.cloudinary.drop_assets',
    defaultMessage: 'Drag and Drop assets here'
  },
  drop_title_single: {
    id: 'shared_components.cloudinary.drop_file',
    defaultMessage: 'Drop a file to upload'
  },
  drop_title_multiple: {
    id: 'shared_components.cloudinary.drop_files',
    defaultMessage: 'Drop files to upload'
  },
  queue_title: {
    id: 'shared_components.cloudinary.upload_queue',
    defaultMessage: 'Upload Queue'
  },
  title_uploading_with_counter: {
    id: 'shared_components.cloudinary.uploading_num_assets',
    defaultMessage: 'Uploading {num} Assets'
  },
  title_uploading: {
    id: 'shared_components.cloudinary.uploading_assets',
    defaultMessage: 'Uploading Assets'
  },
  mini_title: {
    id: 'shared_components.cloudinary.uploaded',
    defaultMessage: 'Uploaded'
  },
  mini_title_uploading: {
    id: 'shared_components.cloudinary.uploading',
    defaultMessage: 'Uploading'
  },
  show_completed: {
    id: 'shared_components.cloudinary.show_completed',
    defaultMessage: 'Show completed'
  },
  retry_failed: {
    id: 'shared_components.cloudinary.retry_failed',
    defaultMessage: 'Retry failed'
  },
  abort_all: {
    id: 'shared_components.cloudinary.abort_all',
    defaultMessage: 'Abort all'
  },
  upload_more: {
    id: 'shared_components.cloudinary.upload_more',
    defaultMessage: 'Upload more'
  },
  done: {
    id: 'shared_components.cloudinary.Done',
    defaultMessage: 'Done'
  },
  mini_upload_count: {
    id: 'shared_components.cloudinary.num_uploaded',
    defaultMessage: '{num} uploaded',
  },
  mini_failed: {
    id: 'shared_components.cloudinary.num_failed',
    defaultMessage: '{num} failed',
  },
  status_uploading: {
    id: 'shared_components.cloudinary.status_uploading',
    defaultMessage: 'Uploading...'
  },
  error: {
    id: 'shared_components.cloudinary.error',
    defaultMessage: 'Error'
  },
  status_uploaded: {
    id: 'shared_components.cloudinary.done',
    defaultMessage: 'Done'
  },
  aborted: {
    id: 'shared_components.cloudinary.aborted',
    defaultMessage: 'Aborted'
  },
  file_too_large: {
    id: 'shared_components.cloudinary.file_size_too_large',
    defaultMessage: 'File size ({size}) exceeds maximum allowed ({allowed})',
  },
  max_dimensions_validation: {
    id: 'shared_components.cloudinary.max_dimensions_validation',
    defaultMessage: 'Image dimensions ({width}X{height}) are bigger than the maximum allowed: ({maxWidth}X{maxHeight})',
  },
  min_dimensions_validation: {
    id: 'shared_components.cloudinary.min_dimensions_validation',
    defaultMessage: 'Image dimensions ({width}X{height}) are smaller than the minimum required: ({minWidth}X{minHeight})',
  },
  unavailable: {
    id: 'shared_components.cloudinary.unavailable',
    defaultMessage: 'NA'
  },
  max_number_of_files: {
    id: 'shared_components.cloudinary.max_number_of_files',
    defaultMessage: 'Maximum number of files exceeded'
  },
  allowed_formats: {
    id: 'shared_components.cloudinary.allowed_files_formats',
    defaultMessage: 'File format not allowed'
  },
  max_file_size: {
    id: 'shared_components.cloudinary.file_too_large',
    defaultMessage: 'File is too large'
  },
  min_file_size: {
    id: 'shared_components.cloudinary.file_too_small',
    defaultMessage: 'File is too small'
  },
  close_mid_upload: {
    id: 'shared_components.cloudinary.uploads_running',
    defaultMessage: 'There are running uploads. Click OK to abort.'
  },
  crop_title: {
    id: 'shared_components.cloudinary.crop_title',
    defaultMessage: 'Crop'
  },
  crop_btn: {
    id: 'shared_components.cloudinary.crop_button',
    defaultMessage: 'Crop'
  },
  skip_btn: {
    id: 'shared_components.cloudinary.skip',
    defaultMessage: 'Skip'
  },
  reset_btn: {
    id: 'shared_components.cloudinary.reset',
    defaultMessage: 'Reset'
  },
  close_btn: {
    id: 'shared_components.cloudinary.yes',
    defaultMessage: 'Yes'
  },
  close_prompt: {
    id: 'shared_components.cloudinary.cancel_all_uploads',
    defaultMessage: 'Closing will cancel all uploads, Are you sure?'
  },
  image_error: {
    id: 'shared_components.cloudinary.error_loading_image',
    defaultMessage: 'Error loading image'
  },
  corner_tooltip: {
    id: 'shared_components.cloudinary.drag_corner_to_resize',
    defaultMessage: 'Drag corner to resize'
  },
  handle_tooltip: {
    id: 'shared_components.cloudinary.drag_handle_to_resize',
    defaultMessage: 'Drag handle to resize'
  },
});

export const getCloudinaryTextData = (intl) => {
  return {
    "or": intl.formatMessage({ ...cloudinaryLocalizationData.or }),
    "menu": {
      "files": intl.formatMessage({ ...cloudinaryLocalizationData.menu_files }),
    },
    "local": {
      "browse": intl.formatMessage({ ...cloudinaryLocalizationData.browse }),
      "dd_title_single": intl.formatMessage({ ...cloudinaryLocalizationData.dd_title_single }),
      "dd_title_multi": intl.formatMessage({ ...cloudinaryLocalizationData.dd_title_multi }),
      "drop_title_single": intl.formatMessage({ ...cloudinaryLocalizationData.drop_title_single }),
      "drop_title_multiple": intl.formatMessage({ ...cloudinaryLocalizationData.drop_title_multiple })
    },
    "queue": {
      "title": intl.formatMessage({ ...cloudinaryLocalizationData.queue_title }),
      "title_uploading_with_counter": intl.formatMessage({ ...cloudinaryLocalizationData.title_uploading_with_counter }, { num: '{{num}}' }),
      "title_uploading": intl.formatMessage({ ...cloudinaryLocalizationData.title_uploading }),
      "mini_title": intl.formatMessage({ ...cloudinaryLocalizationData.mini_title }),
      "mini_title_uploading": intl.formatMessage({ ...cloudinaryLocalizationData.mini_title_uploading }),
      "show_completed": intl.formatMessage({ ...cloudinaryLocalizationData.show_completed }),
      "retry_failed": intl.formatMessage({ ...cloudinaryLocalizationData.retry_failed }),
      "abort_all": intl.formatMessage({ ...cloudinaryLocalizationData.abort_all }),
      "upload_more": intl.formatMessage({ ...cloudinaryLocalizationData.upload_more }),
      "done": intl.formatMessage({ ...cloudinaryLocalizationData.done }),
      "mini_upload_count": intl.formatMessage({ ...cloudinaryLocalizationData.mini_upload_count }, { num: '{{num}}' }),
      "mini_failed": intl.formatMessage({ ...cloudinaryLocalizationData.mini_failed }, { num: '{{num}}' }),
      "statuses": {
        "uploading": intl.formatMessage({ ...cloudinaryLocalizationData.status_uploading }),
        "error": intl.formatMessage({ ...cloudinaryLocalizationData.error }),
        "uploaded": intl.formatMessage({ ...cloudinaryLocalizationData.status_uploaded }),
        "aborted": intl.formatMessage({ ...cloudinaryLocalizationData.aborted })
      }
    },
    "uploader": {
      "errors": {
        "file_too_large": intl.formatMessage({ ...cloudinaryLocalizationData.file_too_large }, { size: '{{size}}', allowed: '{{allowed}}' }),
        "max_dimensions_validation": intl.formatMessage({ ...cloudinaryLocalizationData.max_dimensions_validation }, { width: '{{width}}', height: '{{height}}', maxWidth: '{{maxWidth}}', maxHeight: '{{maxHeight}}' }),
        "min_dimensions_validation": intl.formatMessage({ ...cloudinaryLocalizationData.min_dimensions_validation }, { width: '{{width}}', height: '{{height}}', minWidth: '{{minWidth}}', minHeight: '{{minHeight}}' }),
        "unavailable": intl.formatMessage({ ...cloudinaryLocalizationData.unavailable }),
        "max_number_of_files": intl.formatMessage({ ...cloudinaryLocalizationData.max_number_of_files }),
        "allowed_formats": intl.formatMessage({ ...cloudinaryLocalizationData.allowed_formats }),
        "max_file_size": intl.formatMessage({ ...cloudinaryLocalizationData.max_file_size }),
        "min_file_size": intl.formatMessage({ ...cloudinaryLocalizationData.min_file_size })
      },
      "close_mid_upload": intl.formatMessage({ ...cloudinaryLocalizationData.close_mid_upload })
    },
    "crop": {
      "title": intl.formatMessage({ ...cloudinaryLocalizationData.crop_title }),
      "crop_btn": intl.formatMessage({ ...cloudinaryLocalizationData.crop_btn }),
      "skip_btn": intl.formatMessage({ ...cloudinaryLocalizationData.skip_btn }),
      "reset_btn": intl.formatMessage({ ...cloudinaryLocalizationData.reset_btn }),
      "close_btn": intl.formatMessage({ ...cloudinaryLocalizationData.close_btn }),
      "close_prompt": intl.formatMessage({ ...cloudinaryLocalizationData.close_prompt }),
      "image_error": intl.formatMessage({ ...cloudinaryLocalizationData.image_error }),
      "corner_tooltip": intl.formatMessage({ ...cloudinaryLocalizationData.corner_tooltip }),
      "handle_tooltip": intl.formatMessage({ ...cloudinaryLocalizationData.handle_tooltip })
    }
  }
}
